module.exports = __webpack_public_path__ + "static/google-analytics-cert-ef27293e5b90235a809bb4ece68f030d.png";